"use client";

import { useState } from "react";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";
import { cn } from "@/lib/utils";

const slot_class_name = cn(
	"h-12! w-12! border! border-slate-200! rounded-lg! bg-white/90! text-slate-800 shadow-sm transition-all duration-200",
	"border-y! border-r! border-l!",
	"[&.isActive]:ring-2 [&.isActive]:ring-blue-500 [&.isActive]:border-transparent!"
);

export const MobileSignupMessage = () => {
	const [access_code, set_access_code] = useState("");

	return (
		<div className="absolute -top-20 left-1/2 transform -translate-x-1/2 w-[400px] max-w-full">
			<div className="bg-blue-50 border border-blue-200 text-blue-900 rounded-3xl py-3 px-4 mb-4 text-center text-sm font-medium shadow-sm">
				Your university/college doesn't have access to StudyStash for mobile. Please go to <strong>studystash.com</strong> in your browser.
			</div>
			<div className="bg-white/95 backdrop-blur-sm rounded-lg border border-slate-200 p-6 shadow-sm">
				<label className="text-slate-700 font-medium text-sm mb-3 block text-center">
					If you think you do have access, enter access code:
				</label>
				<div className="flex justify-center">
					<InputOTP
						maxLength={6}
						value={access_code}
						onChange={set_access_code}
					>
						<InputOTPGroup className="gap-2">
							{[0, 1, 2, 3, 4, 5].map((index) => (
								<InputOTPSlot key={index} index={index} className={slot_class_name} />
							))}
						</InputOTPGroup>
					</InputOTP>
				</div>
			</div>
		</div>
	);
};
